import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/resistor-network-calculator',
  component: () => import('../../routes/ResistorNetworkCalculator.svelte'),
  card: {
    id: 'resistor-network-calculator',
    title: 'Resistor Network Calculator',
    description:
      'Calculate total resistance for resistors in series or parallel, decode 4-band and 5-band resistor color codes, and find the nearest E12/E24 standard value for any total.',
    icon: 'memory',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/resistor-network-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Resistor Network Calculator – Series, Parallel, and Color Code Decoder',
    description:
      'Free resistor network calculator. Compute total resistance for series (R1 + R2 + …) and parallel (1/R = 1/R1 + 1/R2 + …) networks, decode 4-band and 5-band color codes per IEC 60062, and find the nearest E12 or E24 standard value for any total.',
  },
};

export default meta;